class ProductsBasketController {
  constructor ($state, ProductUtilsService, VehicleService, ProductService, $log) {
    'ngInject'
    this.$state = $state
    this.productUtilsService = ProductUtilsService
    this.vehicleService = VehicleService
    this.productService = ProductService
    this.$log = $log
    this.loaded = this.init()
  }

  init () {
    this.isBuyable = false
    return this.vehicleService.getCurrentSelectedVehicle()
    .then((v) => {
      if (!v) {
        return Promise.reject('Unable to get current selected vehicle')
      }
      this.vehicle = v
      if (this.product.infoCode === 7 && this.productUtilsService.isContent(this.product)) {
        return this.productService.getIsPreviouslyInstalled(this.product.ref, this.vehicle.vin)
      } else {
        return Promise.resolve(false)
      }
    })
    .then((userOwnLastestVersion) => {
      if (userOwnLastestVersion) {
        this.infoCode = 0
      }
      this.isBuyable = this.productUtilsService.isBuyable(this.product, this.vehicle, userOwnLastestVersion)
      this.isProcessing = false
      return Promise.resolve()
    }, (err) => {
      this.$log.error(err)
      this.error = err
      this.isProcessing = false
      return Promise.reject()
    })
  }

  get icon () {
    if (this.label === 'productDetails.renew' || this.label === 'productDetails.extend') {
      return '/img/car.png'
    } else {
      return '/img/basket.png'
    }
  }

  get label () {
    return this.productUtilsService.getButtonLabel(this.product)
  }

  goPurchase () {
    const productId = this.product.ref
    return this.checkDeviceTotalSpace()
    .then(() => {
      if (this.spaceWarning) {
        return this.$state.go('vehicle.productDetails', {ref: productId})
      } else {
        return this.$state.go('managePurchase.myPurchase', {productId})
      }
    })
  }

  checkDeviceTotalSpace () {
    console.log('VIN = ' + this.vehicle.vin)
    console.log('MUS packageNameMus: ' + this.product.packageNameMus)
    if (this.product.tomtomId && (this.product.tomtomId.substring(0, 4) === 'map/' || this.product.tomtomId.substring(0, 11) === 'mappackage_')) {
      console.log('Map ' + this.product.ref + ' has tomtomId = ' + this.product.tomtomId)
      return this.productService.checkIfMapIsInstallable(this.vehicle.vin, this.product.ref)
      .then((response) => {
        console.log('This map is installable: ' + response)
        if (response === 'TOTAL_SPACE_NOT_ENOUGH') {
          // console.log('This map is not installable because no mount is big enough for this map')
          this.spaceWarning = true
        }
        return Promise.resolve()
      })
    } else if (this.product.packageNameMus && (this.product.packageNameMus.substring(0, 4) === 'map/' || this.product.packageNameMus.substring(0, 11) === 'mappackage_')) {
      console.log('MUS ' + this.product.ref + ' has packageNameMus = ' + this.product.packageNameMus)
      return this.productService.checkIfLatestMapIsInstallable(this.vehicle.vin, this.product.ref)
      .then((response) => {
        console.log('The latest map available is installable: ' + response)
        if (response === 'TOTAL_SPACE_NOT_ENOUGH') {
          // console.log('The latest map available is not installable because no mount is big enough for this map')
          this.spaceWarning = true
        }
        return Promise.resolve()
      })
    } else {
      this.spaceWarning = false
      return Promise.resolve()
    }
  }
}

export default ProductsBasketController



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/catalog/components/products-basket/products-basket.controller.js